module.exports = __webpack_public_path__ + "static/media/Hollow.f04f9ea4.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/Hollow.png
// module id = 352
// module chunks = 0